import { getAuth } from './token';
import { OpenAPI as OpenApiNew } from 'api-new/generated';
import { OpenAPI } from 'api/generated';
import axios from 'axios';
import { REACT_APP_API_BASE_URL } from 'config';

const setupHttp = () => {
  OpenAPI.BASE = REACT_APP_API_BASE_URL;
  OpenAPI.TOKEN = async () => {
    const auth = getAuth();
    if (auth && auth.token) {
      return auth.token;
    }
    return '';
  };
};

const setupHttpNew = () => {
  OpenApiNew.BASE = REACT_APP_API_BASE_URL;
  OpenApiNew.TOKEN = async () => {
    const auth = getAuth();
    if (auth && auth.token) {
      return auth.token;
    }
    return '';
  };
};

const createClient = (url: string) => {
  return axios.create({
    baseURL: url,
    timeout: 30000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  });
};

const httpClient = createClient(REACT_APP_API_BASE_URL);

httpClient.interceptors.request.use(
  (config) => {
    const auth = getAuth();
    if (auth && auth.token) {
      config.headers.Authorization = `Bearer ${auth.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { httpClient, setupHttp, setupHttpNew };
